import { IconColor, IconID } from '@hub/common/Icon/Icon';
import { Link } from '@hub/common/Link/Link';
import type { LeadIn } from '@hub/models/api/page-content.types';

const LeadInBanner = ({ leadInJson }: { leadInJson: LeadIn }) => (
  <section className="bg-[#f8f8f8] py-3" data-testid="lead-in">
    <div className="container text-black text-[16px] flex justify-between ">
      {leadInJson?.links &&
        leadInJson.links.map(link => {
          const isWhatsapp = IconID.WHATSAPP.match(link.icon);
          return (
            <Link
              className="hover:text-igus-primary [&>span>svg]:h-9 [&>span>svg]:w-9"
              iconPrimary={!isWhatsapp}
              iconColor={isWhatsapp && IconColor.WHATSAPP}
              key={link.text}
              href={link.href}
              text={link.text}
              icon={`igus-icon-${link.icon || ''}` as IconID}
            />
          );
        })}
    </div>
  </section>
);

export { LeadInBanner };
